"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageLens = exports.step2TabLens = exports.step1StatusLens = exports.UserDataLens = exports.step1ErrorsLens = exports.userLens = exports.step1Lens = exports.hasAcceptedMarketingConsentLens = exports.acceptedTermLens = exports.avatarLens = exports.hasAcceptedTermsLens = exports.stepLens = exports.regionStatus = exports.regionList = exports.company = exports.step1 = exports.status = exports.ytjLens = exports.customerLens = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/firstLogin/form");
const CustomerActions = require("../../actionTypes/firstLogin/customer");
const customer = require("./customer");
const ytj = require("./ytj");
//#endregion
//#region INITIAL STATE
exports.initialState = {
    page: 0,
    termsVersion: 1,
    hasAcceptedTerms: false,
    hasAcceptedMarketingConsent: false,
    avatar: '',
    customerId: NaN,
    status: 'STANDBY',
    step1: {
        status: 'INITIAL',
        user: {
            firstName: '',
            lastName: '',
            title: '',
            telephone: '',
            email: '',
            language: 'English',
            street: '',
            postalCode: '',
            city: '',
            country: '',
            avatar: '',
            hasAcceptedTerms: false,
            termsVersion: 1
        }
    },
    regions: {
        status: 'STANDBY',
        list: []
    },
    customer: Object.assign({}, customer.initialState),
    ytj: Object.assign({}, ytj.initialState)
};
//#endregion
//#region LENS
exports.customerLens = monocle.Lens.fromProp('customer');
exports.ytjLens = monocle.Lens.fromProp('ytj');
exports.status = monocle.Lens.fromProp('status');
exports.step1 = monocle.Lens.fromProp('step1');
exports.company = monocle.Lens.fromProp('customerId');
exports.regionList = monocle.Lens.fromPath([
    'regions',
    'list'
]);
exports.regionStatus = monocle.Lens.fromPath([
    'regions',
    'status'
]);
exports.stepLens = monocle.Lens.fromProp('page');
// FIXME: redundant lens definition, the accepterTermLens hooks to exactly same piece of the state
exports.hasAcceptedTermsLens = monocle.Lens.fromProp('hasAcceptedTerms');
exports.avatarLens = monocle.Lens.fromProp('avatar');
exports.acceptedTermLens = monocle.Lens.fromProp('hasAcceptedTerms');
exports.hasAcceptedMarketingConsentLens = monocle.Lens.fromProp('hasAcceptedMarketingConsent');
exports.step1Lens = monocle.Lens.fromProp('step1');
exports.userLens = monocle.Lens.fromProp('user');
exports.step1ErrorsLens = new monocle.Optional((a) => (a.status === 'ERROR' ? fp.option.some(a.errors) : fp.option.none), (a) => (s) => (s.status === 'ERROR' ? Object.assign(Object.assign({}, s), { errors: a }) : s));
const UserDataLens = (key, value) => monocle.Lens.fromProp(key).set(value);
exports.UserDataLens = UserDataLens;
exports.step1StatusLens = monocle.Lens.fromProp('status');
exports.step2TabLens = new monocle.Setter((page) => (state) => {
    const step1 = exports.step1Lens.get(state);
    return exports.step1Lens.set(Object.assign({}, step1))(state);
});
exports.pageLens = monocle.Lens.fromProp('page');
const methods = {};
methods[Actions.VALIDATE_STEP_FAILURE] = (state, action) => fp.function.compose(exports.step1Lens
    .asOptional()
    .compose(exports.step1ErrorsLens)
    .set(action.payload.errors.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {})), exports.step1Lens.compose(exports.step1StatusLens).set('ERROR'))(state);
methods[Actions.VALIDATE_STEP_SUCCESS] = (state, action) => fp.function.compose(exports.stepLens.set(action.payload.page), exports.step1Lens.compose(exports.step1StatusLens).set('INITIAL'), exports.step1Lens.asOptional().compose(exports.step1ErrorsLens).set({}))(state);
methods[Actions.CHANGE_ACCEPT_TERMS] = (state, action) => exports.acceptedTermLens.set(action.payload.hasAcceptedTerms)(state);
methods[Actions.ACCEPT_MARKETING_CONSENT] = (state, action) => exports.hasAcceptedMarketingConsentLens.set(action.payload.hasAcceptedMarketingConsent)(state);
methods[Actions.SET_COMPANY] = (state, action) => exports.company.set(action.payload)(state);
methods[Actions.SET_USER_AVATAR] = (state, action) => exports.avatarLens.set(action.payload.avatar)(state);
methods[Actions.SET_USER_DATA] = (state, action) => exports.step1Lens.set({ user: Object.assign({}, action.payload), status: 'INITIAL' })(state);
methods[Actions.UPDATE_USER_DATA] = (state, action) => exports.step1.modify(exports.userLens.modify((0, exports.UserDataLens)(action.payload.field, action.payload.value)))(state);
methods[Actions.SUBMIT_FIRST_LOGIN_REQUEST] = (state, action) => exports.status.set('SAVING')(state);
methods[Actions.SUBMIT_FIRST_LOGIN_SUCCESS] = (state, action) => exports.status.set('SAVED')(state);
methods[Actions.SUBMIT_FIRST_LOGIN_FAILED] = (state, action) => exports.status.set('FAILED')(state);
methods[Actions.FETCH_REGIONS_REQUEST] = (state, action) => exports.regionStatus.set('FETCHING')(state);
methods[Actions.FETCH_REGIONS_SUCCESS] = (state, action) => fp.function.compose(exports.regionStatus.set('FETCHED'), exports.regionList.set(action.payload))(state);
methods[Actions.FETCH_REGIONS_FAILED] = (state, action) => exports.regionStatus.set('FAILED')(state);
methods[Actions.SHOULD_REDIRECT_USER_TO_TERMS_PAGE_SUCCESS] = (state, action) => {
    if (action.payload.message) {
        return exports.stepLens.set(0)(state);
    }
    return state;
};
methods[CustomerActions.CREATE_CUSTOMER_SUCCESS] = (state, action) => {
    return exports.step1Lens
        .asOptional()
        .compose(exports.step1ErrorsLens)
        .modify((s) => {
        s['company'] && delete s['company'];
        return s;
    })(state);
};
//#endregion
const handleIndex = (action) => (state) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
const handleCustomer = (action) => (state) => {
    const fn = customer.methods[action.type];
    if (fn) {
        return exports.customerLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleYtj = (action) => (state) => {
    const fn = ytj.methods[action.type];
    if (fn) {
        return exports.ytjLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
exports.default = (state = exports.initialState, action) => {
    return fp.function.compose(handleYtj(action), handleCustomer(action), handleIndex(action))(state);
};
//# sourceMappingURL=index.js.map